import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTemperatureQuarter } from '@fortawesome/free-solid-svg-icons';

import { FormattedValue } from './FormattedValue';

interface TemperatureStatsProps {
    temperature: number;
    temperatureFeel: number;
    isLoaded: boolean;
}

const TemperatureStats: React.FC<TemperatureStatsProps> = ({ temperature, temperatureFeel, isLoaded }) => {

    return <div className="column is-one-third metric rain-container">
                <div className="is-flex is-flex-direction-column">
                    <FontAwesomeIcon color='orange' size='2x' icon={faTemperatureQuarter} />
                    <FormattedValue isLoaded={isLoaded} value={temperature} unit='ºC'></FormattedValue>
                    <FormattedValue isLoaded={isLoaded} value={temperatureFeel} unit='ºC' isSmall={true}></FormattedValue>
                    <span className="is-size-7">(sensação)</span>
                </div>
            </div>
}

export default TemperatureStats;
